module.exports = __webpack_public_path__ + "18423e339e6731eac3d3130d1f11be75.svg";